import LocationLayer from '@client-shared/models/location-layer.model.js'

export const getLocationLayers = async ({ axios, projectId }) => {
  const { data } = await axios.get('location-layers', {
    params: {
      projectid: projectId,
    },
  })

  return data.map(locationLayer => Object.freeze(new LocationLayer(locationLayer)))
}

export const getLocationLayerTileList = async ({ axios, locationLayerId, locationLayerVersionId, maxZoomLevel }) => {
  const params = {}

  if (maxZoomLevel !== undefined) {
    params.maxZoomLevel = maxZoomLevel
  }

  const { data } = await axios.get(`location-layers/${locationLayerId}/versions/${locationLayerVersionId}/tile-list`, {
    params,
  })

  return data
}

export const postLocationLayer = async ({ axios, locationLayer }) => {
  const { data } = await axios.post('location-layers', locationLayer, {
    params: {
      projectid: locationLayer.projectId,
    },
  })

  return new LocationLayer(data)
}

export const patchLocationLayerTitle = async ({ axios, locationLayer, title }) => {
  const patchObject = {
    op: 'update',
    path: 'title',
    value: {
      old: locationLayer.title,
      new: title,
    },
  }

  const { data } = await axios.patch(`location-layers/${locationLayer._id}`, patchObject)

  return new LocationLayer(data)
}

export const patchLocationLayerIsActive = async ({ axios, locationLayer, isActive }) => {
  const patchObject = {
    op: 'update',
    path: 'isActive',
    value: {
      old: locationLayer.isActive,
      new: isActive,
    },
  }

  const { data } = await axios.patch(`location-layers/${locationLayer._id}`, patchObject)

  return new LocationLayer(data)
}

export const patchLocationLayerLocationRestrictions = async ({ axios, locationLayer, locationRestrictions }) => {
  const patchObject = {
    op: 'update',
    path: 'locationRestrictions',
    value: {
      old: locationLayer.locationRestrictions,
      new: locationRestrictions,
    },
  }

  const { data } = await axios.patch(`location-layers/${locationLayer._id}`, patchObject)

  return new LocationLayer(data)
}

export const patchLocationLayerActiveVersionId = async ({ axios, locationLayer, activeVersionId }) => {
  const patchObject = {
    op: 'update',
    path: 'activeVersionId',
    value: {
      old: locationLayer.activeVersionId,
      new: activeVersionId,
    },
  }

  const { data } = await axios.patch(`location-layers/${locationLayer._id}`, patchObject)

  return new LocationLayer(data)
}

export const postLocationLayerVersion = async ({ axios, locationLayerId, sourcePfFileId }) => {
  const { data } = await axios.post(`location-layers/${locationLayerId}/versions`, {
    sourcePfFileId,
  })

  return new LocationLayer(data)
}

export const deleteLocationLayer = async ({ axios, locationLayerId }) => {
  await axios.delete(`location-layers/${locationLayerId}`)
}

export const deleteLocationLayerVersion = async ({ axios, locationLayerId, locationLayerVersionId }) => {
  await axios.delete(`location-layers/${locationLayerId}/versions/${locationLayerVersionId}`)
}

export const reorderLocationLayers = async ({ axios, projectId, oldValue, newValue }) => {
  const { data } = await axios.post('location-layers/reorder', {
    projectId,
    value: {
      old: oldValue,
      new: newValue,
    },
  })

  return data.map(locationLayer => Object.freeze(new LocationLayer(locationLayer)))
}
